import { useMemo } from 'react';

import ResponseMessage from '@/components/Error/ResponseMessage';
import { HStack, VStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { colSpanClasses } from '@/constants/colSpan';
import { useCommonTranslation } from '@/hooks/useCommonTranslation';
import { cn } from '@/lib/cn';

import type { CFormItemComponentBaseProps } from '../../types/component-types';

type CFormItemBaseProps = CFormItemComponentBaseProps;

export function CFormLabelItemLayout(props: CFormItemBaseProps) {
  const t = useCommonTranslation();
  const errors = useMemo(() => {
    return typeof props.errors === 'string'
      ? props.errors
      : props.errors?.join('\n');
  }, [props.errors]);

  return (
    <VStack
      className={cn(
        'min-w-0 gap-1 py-2 w-full',
        colSpanClasses[props.colSpan ?? 2],
      )}
    >
      <HStack className={'gap-2 items-start h-4'}>
        {typeof props.label === 'string' ? (
          <Text variant="label" className="text-neutral-muted-on-fill">
            {props.label}
          </Text>
        ) : (
          props.label
        )}
        {props.isEditing && !props.required && (
          <Text variant="labelSmall" className="text-muted-foreground">
            {t('optional')}
          </Text>
        )}
      </HStack>
      {props.isEditing ? (
        <VStack className="w-full min-w-0">
          {props.writeComponent}
          {errors && (
            <ResponseMessage className="whitespace-pre-line">
              {errors}
            </ResponseMessage>
          )}
        </VStack>
      ) : (
        <Text variant="labelSemiLarge" className="text-neutral-on-fill">
          {props.readComponent}
        </Text>
      )}
    </VStack>
  );
}
